import type { RxJsonSchema } from 'rxdb'

export interface CycleWorkItemDocument {
  id: string
  envId: string
  cycleId: string
  workItemId: string
  statusIdAtClose: string | null
  progressTypeAtClose: string | null
  addedAt: number
  sourceCycleId: string | null
  isDeleted: boolean
  createdOn: number
  createdBy: string
  updatedOn: number
  updatedBy: string
  deletedOn?: number | null
  deletedBy?: string | null
  updatedAt?: number
}

export const cycleWorkItemSchema: RxJsonSchema<CycleWorkItemDocument> = {
  version: 1,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 36 },
    envId: { type: 'string', maxLength: 36 },
    cycleId: { type: 'string', maxLength: 36 },
    workItemId: { type: 'string', maxLength: 36 },
    statusIdAtClose: { type: ['string', 'null'], maxLength: 36 },
    progressTypeAtClose: { type: ['string', 'null'], maxLength: 20 },
    addedAt: { type: 'number', minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    sourceCycleId: { type: ['string', 'null'], maxLength: 36 },
    isDeleted: { type: 'boolean', default: false },
    createdOn: { type: 'number', minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    createdBy: { type: 'string', maxLength: 36 },
    updatedOn: { type: 'number', minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    updatedBy: { type: 'string', maxLength: 36 },
    deletedOn: { type: ['number', 'null'], minimum: 0, maximum: 9999999999999, multipleOf: 1 },
    deletedBy: { type: ['string', 'null'], maxLength: 36 },
    updatedAt: { type: 'number', minimum: 0, maximum: 9999999999999, multipleOf: 1 },
  },
  required: [
    'id',
    'envId',
    'cycleId',
    'workItemId',
    'addedAt',
    'sourceCycleId',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  indexes: ['envId', 'updatedOn', ['envId', 'isDeleted'], ['envId', 'cycleId'], ['envId', 'workItemId']],
}

export const cycleWorkItemMigrationStrategies = {
  // v0 -> v1: backfill `addedAt` (required number; default = createdOn) and
  // `sourceCycleId` (nullable). Pre-feature docs predate cycle copy-forward.
  1: (oldDoc: any): any => ({
    ...oldDoc,
    addedAt: oldDoc.addedAt ?? oldDoc.createdOn ?? Date.now(),
    sourceCycleId: oldDoc.sourceCycleId ?? null,
  }),
}
